
import XHeader from 'vux/src/components/x-header/index.vue'

import {mapState,mapMutations} from 'vuex'
import { getNewsLsit } from '../service/getdata'
export default {
data(){
return{
newsList:[],
}
},
components:{
XHeader
},
computed:{
...mapState(['token'])
},
created(){
this.SETTOKEN()
this.getData();
},
methods:{
...mapMutations(['SETTOKEN']),
getData(){
var that = this
this.$Loading()
getNewsLsit({token: this.token}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
that.newsList = res.data.data
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}
}.bind(this),function(){
that.$Loading.close()
console.log("error")
})
},

}
}



// WEBPACK FOOTER //
// ./src/pages/news.vue